const publicKeyEnvironmentVariable = 'REACT_APP_AUTH_PUBLIC_KEY';

const pemToDer = (pem: string) => {
  const base64 = pem
    .replace(/\\n/g, '\n')
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s/g, '');
  const binary = window.atob(base64);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
};

const toBase64 = (bytes: ArrayBuffer) => {
  const binary = String.fromCharCode(...new Uint8Array(bytes));
  return window.btoa(binary);
};

export const encryptPassword = async (password: string): Promise<string> => {
  const pem = process.env.REACT_APP_AUTH_PUBLIC_KEY;
  if (!pem) {
    throw new Error(`${publicKeyEnvironmentVariable} is not configured`);
  }

  const publicKey = await window.crypto.subtle.importKey(
    'spki',
    pemToDer(pem),
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  );
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    new TextEncoder().encode(password)
  );

  return toBase64(encrypted);
};
